import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
	0%, 100% {
		opacity: 0.8;
	}
	50% {
		opacity: 0.5;
	}
`;

// Soft halo in the app's primary blue: hold briefly so it's visible once the smooth-scroll settles,
// then fade out once. Colour pulled from theme (blue[6]); the trailing hex sets the alpha (66 ~= 0.4).
const highlightFade = (color: string) => keyframes`
	0% {
		box-shadow: 0 0 0 3px ${color}66;
	}
	65% {
		box-shadow: 0 0 0 3px ${color}66;
	}
	100% {
		box-shadow: 0 0 0 3px ${color}00;
	}
`;

export const SecurityRankingPageContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	padding-top: 1rem;

	.ranking-container {
		display: flex;
		margin-top: 1rem;
		gap: 1rem;
		height: 100%;
	}

	.sidebar {
		display: flex;
		flex-direction: column;
		height: 100%;
		flex: 0 0 436px;
		border: ${(props) => `1px solid ${props.theme.v3.colors.gray[4]}`};
		border-radius: 0.25rem;
		padding: 0.5rem;

		&-title {
			margin-bottom: 0.5rem;
			padding: 0.5rem;
		}

		&-content {
			overflow: auto;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 0.5rem;
			padding-bottom: 10rem;
		}
	}

	.ranking-content {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		flex: 1;
		overflow: auto;
		height: 100%;
		padding-bottom: 10rem;

		.droppable-rank-sticky {
			position: sticky;
			top: 0;
			z-index: 20;
		}
	}

	.loading {
		animation: ${pulse} 2s ease-in-out infinite;
		pointer-events: none;
	}

	.security-card-highlight {
		border-radius: 0.25rem;
		animation: ${({ theme }) => highlightFade(theme.v3.colors.blue[6])} 2.2s ease-out;
	}
`;

export const DraggedSecurityRankCards = styled.div`
	display: flex;
	flex-direction: column;
`;
